import React, { useEffect, useRef, useState } from "react";
import { createClient } from "@supabase/supabase-js";
import { useHistory } from 'react-router-dom';
import { Button, Card, Text, Skeleton } from "@pancakeswap/uikit";
import Page from "../PageChart";
import { legacyData } from "../Home/components/legacyData"; // fontos: útvonal igazítása

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL!,
  process.env.REACT_APP_SUPABASE_KEY!
);

interface DataPoint {
  timestamp: string;
  price: number;
}

const sampleData = (data: DataPoint[], count: number): DataPoint[] => {
  if (data.length <= count) return data; // ne fordítsd meg!
  const step = (data.length - 1) / (count - 1);
  return Array.from({ length: count }, (_, i) => data[Math.floor(i * step)]);
};


const Partnership: React.FC = () => {
  const [data, setData] = useState<DataPoint[]>([]);
  const [timeframe, setTimeframe] = useState<"1h" | "1d" | "1w" | "1m" | "1y" | "all">("1d");
  const [hoveredPoint, setHoveredPoint] = useState<DataPoint | null>(null);
  const [currentPrice, setCurrentPrice] = useState<number | null>(null);
  const [changePercent, setChangePercent] = useState<number | null>(null);
  const [minPrice, setMinPrice] = useState<number | null>(null);
  const [maxPrice, setMaxPrice] = useState<number | null>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const from = "2025-05-25T16:00:00Z";

      const { data: fresh, error } = await supabase
        .from("vizslachart")
        .select("timestamp, price")
        .gte("timestamp", from)
        .order("timestamp", { ascending: true });

      const cleanedFresh = (fresh ?? []).filter(d =>
        d.timestamp && typeof d.price === "number" && !Number.isNaN(d.price)
      );

      const fullData = [...legacyData, ...cleanedFresh];

      if (fullData.length < 2) {
        setData(fullData);
        setCurrentPrice(fullData[0]?.price ?? null);
        setChangePercent(null);
        setMinPrice(fullData[0]?.price ?? null);
        setMaxPrice(fullData[0]?.price ?? null);
        return;
      }

      const targetCount = {
        "1h": 12,
        "1d": 24,
        "1w": 60,
        "1m": 30,
        "1y": 36,
        "all": 36,
      }[timeframe];

const now = new Date();
const timeframeDurations: Record<typeof timeframe, number> = {
  "1h": 60,
  "1d": 24 * 60,
  "1w": 7 * 24 * 60,
  "1m": 30 * 24 * 60,
  "1y": 365 * 24 * 60,
  "all": 0,
};

const cutoff = timeframe === "all"
  ? new Date("2000-01-01")
  : new Date(now.getTime() - timeframeDurations[timeframe] * 60000);

const filtered = fullData.filter(d => new Date(d.timestamp) >= cutoff);

const sampled = sampleData(filtered, targetCount);

      const prices = sampled.map((d) => d.price);
    const first = sampled[0]; // régi
const latest = sampled.reduce((a, b) =>
  new Date(a.timestamp) > new Date(b.timestamp) ? a : b
);

      const change = ((latest.price - first.price) / first.price) * 100;

      setData(sampled);
      setCurrentPrice(latest.price);
      setChangePercent(change);
      setMinPrice(Math.min(...prices));
      setMaxPrice(Math.max(...prices));
    };

    fetchData();
  }, [timeframe]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || data.length === 0) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const width = canvas.width;
    const height = canvas.height;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = "#0b0e11";
    ctx.fillRect(0, 0, width, height);

    const chartHeight = height - 60;
    const priceRange = (maxPrice ?? 1) - (minPrice ?? 0.1) || 1;
    const points = data.map((point, i) => {
      const x = (i / (data.length - 1)) * width;
      const y = ((maxPrice! - point.price) / priceRange) * chartHeight + 10;
      return { x, y };
    });

    ctx.beginPath();
    points.forEach((p, i) => (i === 0 ? ctx.moveTo(p.x, p.y) : ctx.lineTo(p.x, p.y)));
    ctx.strokeStyle = "#00e8b2";
    ctx.lineWidth = 2;
    ctx.stroke();
  }, [data, maxPrice, minPrice]);

  const handleMouseMove = (e: React.MouseEvent) => {
    const canvas = canvasRef.current;
    if (!canvas || data.length === 0) return;
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const index = Math.round((x / canvas.width) * (data.length - 1));
    setHoveredPoint(data[index]);
  };

  return (
    <Page>
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1rem" }}>

      <Button
        scale="sm"
        variant="secondary"
        onClick={() => history.push("/chartshvi")}
      >
        HVI Chart
      </Button>
      </div>
<div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
  <Card style={{ background: "#0b0e11", padding: "0.75rem", borderRadius: "1rem", width: "100%", maxWidth: "680px" }}>
       <div style={{ display: "flex", gap: "0.2rem", marginBottom: "1rem", flexWrap: "wrap" }}>
         {["1h", "1d", "1w", "1m", "1y", "all"].map((tf) => (
           <Button
             key={tf}
             scale="sm"
             variant={timeframe === tf ? "primary" : "tertiary"} 
             onClick={() => setTimeframe(tf as any)}
           >
             {tf === "1w" ? "7d" : tf.toUpperCase()}
           </Button>
         ))}
       </div>
 
       {data.length === 0 ? (
         <Text color="textSubtle" fontSize="14px">Nincs elérhető adat.</Text>
       ) : (
         <>
           <div style={{ position: "relative", width: "100%" }}>
             <canvas
               ref={canvasRef}
               width={600}
               height={190}
               style={{ borderRadius: "8px", cursor: "crosshair", width: "100%" }}
               onMouseMove={handleMouseMove}
               onMouseLeave={() => setHoveredPoint(null)}
             />
           </div>
 
           <div style={{ color: "white", fontSize: "14px", backgroundColor: "rgba(0, 0, 0, 0.4)", padding: "8px 12px", borderRadius: "8px", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "2rem" }}>
             <div style={{ display: "flex", flexDirection: "column", color: "#7f8fa3", fontSize: "12px" }}>
               <div>Min: ${minPrice?.toFixed(6) ?? "–"}</div>
               <div>Max: ${maxPrice?.toFixed(6) ?? "–"}</div>
               <Text color="white" bold fontSize="15px">VizslaSwap Chart</Text>
             </div>
             <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
               <div style={{ fontWeight: "bold" }}>
                 ${(hoveredPoint?.price ?? currentPrice)?.toFixed(6) ?? "–"}
               </div>
               <div style={{ fontSize: "12px", color: "#7f8fa3" }}>
                 {new Date((hoveredPoint ?? data.at(-1))?.timestamp).toLocaleString("hu-HU", {
                   year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"
                 })} 
               </div>
               <div style={{ fontSize: "12px", color: changePercent && changePercent < 0 ? "#ff4b4b" : "#00e8b2" }}>
                 {changePercent != null ? `${changePercent >= 0 ? "+" : ""}${changePercent.toFixed(2)}%` : "–"}
               </div>
             </div>
           </div>
         </>
       )}
     </Card>
   </div>
    </Page>
  );
};

export default Partnership;